export enum ConnectionStatus {
    Connecting,
    Connected,
    Disconnected
}

export enum BreakStatus {
    Apply,
    Start,
    Cancel,
    End
}